import { render } from "./NewsFlash.vue?vue&type=template&id=44b88622"
import script from "./NewsFlash.vue?vue&type=script&lang=js"
export * from "./NewsFlash.vue?vue&type=script&lang=js"

import "./NewsFlash.vue?vue&type=style&index=0&id=44b88622&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__